import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { DemoFirstNote } from "./DemoFirstNote";
import { SITE } from "../config";

export const CTABand = ({ title = "Your website could be live by the weekend.", sub }) => (
  <section className="container-x pb-14 pt-2 sm:pb-20 sm:pt-6" data-testid="final-cta-band">
    <Reveal>
      <div className="grain relative overflow-hidden rounded-3xl border border-volt/20 bg-gradient-to-br from-surface via-card to-ink px-6 py-12 text-center sm:px-12 sm:py-16">
        <div
          className="absolute inset-0 opacity-60"
          style={{
            background:
              "radial-gradient(circle at 50% 0%, rgba(0,240,255,0.16), transparent 55%)",
          }}
          aria-hidden="true"
        />
        <div className="relative">
          <p className="eyebrow">Free 20-minute demo</p>
          <h2 className="mx-auto mt-3 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-5xl">
            {title}
          </h2>
          <p className="mx-auto mt-4 font-display text-xl font-extrabold tracking-tight text-volt glow-text sm:text-2xl">
            ${SITE.price} flat · Live in 72 hours
          </p>
          <p className="mx-auto mt-3 max-w-xl text-sm text-mist sm:text-base">
            {sub || "See your future website before you pay anything. No credit card, no pressure."}
          </p>
          <div className="mt-5 flex justify-center">
            <DemoFirstNote testId="cta-band-demo-first-note" />
          </div>
          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
            <Link to="/book-demo" data-testid="cta-band-button" className="btn-primary">
              Book a Free Demo <ArrowRight size={16} strokeWidth={2.5} />
            </Link>
            <Link to="/how-it-works" data-testid="cta-band-secondary" className="btn-secondary">
              See How It Works
            </Link>
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
